import { z } from "zod";
import { AZURE_DEPLOYMENT_STATUSES, AZURE_RESOURCE_TYPES } from "../constants.js";
export const createDeploymentSchema = z.object({
    companyId: z.string().uuid(),
    agentId: z.string().uuid().optional(),
    name: z.string().min(1).max(100),
    region: z.string().min(1).max(50).optional(),
    vmSize: z.string().min(1).max(50).optional(),
    resourceType: z.enum(AZURE_RESOURCE_TYPES).optional(),
    identityContent: z.string().max(50000).optional(),
    soulContent: z.string().max(50000).optional(),
});
export const updateDeploymentSchema = z.object({
    status: z.enum(AZURE_DEPLOYMENT_STATUSES).optional(),
    vmSize: z.string().min(1).max(50).optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const resizeDeploymentSchema = z.object({
    vmSize: z.string().min(1).max(50),
});
export const runCommandSchema = z.object({
    command: z.string().min(1).max(10000),
});
export const testCredentialsSchema = z.object({
    tenantId: z.string().min(1),
    clientId: z.string().min(1),
    clientSecret: z.string().min(1),
});
export const setupNetworkingSchema = z.object({
    resourceGroupName: z.string().min(1).max(100).optional(),
    vnetName: z.string().min(1).max(100).optional(),
    subnetName: z.string().min(1).max(100).optional(),
    addressPrefix: z.string().optional(),
    subnetPrefix: z.string().optional(),
    location: z.string().min(1).max(50).optional(),
});
export const createScheduleSchema = z.object({
    deploymentId: z.string().uuid(),
    action: z.enum(["start", "stop"]),
    cronExpression: z.string().min(1).max(100),
    timezone: z.string().max(50).optional(),
    enabled: z.boolean().optional(),
});
export const updateScheduleSchema = z.object({
    action: z.enum(["start", "stop"]).optional(),
    cronExpression: z.string().min(1).max(100).optional(),
    timezone: z.string().max(50).optional(),
    enabled: z.boolean().optional(),
});
export const provisioningCallbackSchema = z.object({
    vmName: z.string(),
    privateIp: z.string(),
    tailscaleIp: z.string().optional(),
    gatewayToken: z.string().optional(),
    managedIdentityId: z.string().optional(),
    status: z.enum(["ready", "error"]),
    error: z.string().optional(),
    timestamp: z.number().optional(),
});
export const deploymentHealthCheckSchema = z.object({
    name: z.string().min(1),
    status: z.enum(["ok", "degraded", "error", "unknown"]),
    message: z.string().min(1),
    observedValue: z.string().min(1),
    expectedValue: z.string().min(1),
});
export const deploymentHealthSchema = z.object({
    status: z.enum(["ok", "degraded", "error", "unknown"]),
    summary: z.string().min(1),
    validatedAt: z.string().datetime(),
    checks: z.array(deploymentHealthCheckSchema),
});
export const deploymentStatusResponseSchema = z.object({
    vmName: z.string().min(1),
    powerState: z.string().min(1),
    provisioningState: z.string().min(1),
    statuses: z.array(z.record(z.unknown())),
    health: deploymentHealthSchema,
});
//# sourceMappingURL=azure.js.map